import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import permissionService from '../services/permission.service'
import userApi, { UserUpdateRequest } from '../apis/user.api'
import siteApi from '../apis/site.api'
import { PermissionData } from '../apis/permission.api'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import Row from '../components/Row/Row'
import InputText from '../components/InputText'
import PermissionPicker from '../components/PermissionPicker'
import PageHeading from '../components/PageHeading'
import Checkbox from '../components/Checkbox'
import storageService from '../services/storage.service'

interface UserEditRouteState {
  id: number
}

interface UserEditProps
  extends RouteComponentProps<any, any, UserEditRouteState> {}

interface UserEditState {
  username: string
  timeout: string
  email: string
  phone: string
  password: string
  notify: boolean
  permissions: PermissionData[]
  allowedPermissions: PermissionData[]
}

class UserEdit extends Component<UserEditProps, UserEditState> {
  constructor (props: UserEditProps) {
    super(props)
    this.state = {
      username: '',
      timeout: '',
      email: '',
      phone: '',
      password: '',
      notify: true,
      permissions: [],
      allowedPermissions: []
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handlePermissionsChange = this.handlePermissionsChange.bind(this)
    this.handleCheckChange = this.handleCheckChange.bind(this)
    this.handleSaveClick = this.handleSaveClick.bind(this)
  }

  get id () {
    return this.props.location.state.id
  }

  get allowedPermissionNames () {
    const { allowedPermissions } = this.state
    return permissionService.listNames(allowedPermissions)
  }

  get permissionNames () {
    const { permissions } = this.state
    return permissionService.listNames(permissions)
  }

  save () {
    const { username, password, email, phone, notify } = this.state
    const { timeout, permissions } = this.state
    const permissionIds = permissionService.listIds(permissions)
    const payload: UserUpdateRequest = {}
    if (username) payload.username = username
    if (password) payload.password = password
    if (email) payload.email = email
    if (phone) payload.phone = phone
    payload.notify = notify
    if (timeout) payload.timeout = Number(timeout)
    if (permissions) payload.permissions = permissionIds
    userApi.update(this.id, payload, user => {
      if (!user) return
      this.props.history.push(routes.users)
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'username') this.setState({ username: value })
    if (name === 'timeout') this.setState({ timeout: value })
    if (name === 'email') this.setState({ email: value })
    if (name === 'phone') this.setState({ phone: value })
    if (name === 'password') this.setState({ password: value })
  }

  handlePermissionsChange (permissionNames: string[]) {
    const { allowedPermissions } = this.state
    const permissions = permissionService.filterByNames(
      allowedPermissions,
      permissionNames
    )
    this.setState({ permissions })
  }

  handleCheckChange (name: string) {
    if (name === 'notify') {
      this.setState(state => {
        return { notify: !state.notify }
      })
    }
  }

  handleSaveClick () {
    this.save()
  }

  listAllowedPermissions () {
    siteApi.listPermissions(allowedPermissions => {
      if (!allowedPermissions) return
      this.setState({ allowedPermissions })
    })
  }

  readUser () {
    userApi.read(this.id, user => {
      if (!user || !user.permissions) return
      const { username, timeout, email, phone, permissions } = user
      this.setState({
        username,
        timeout: String(timeout),
        email: email || '',
        phone: phone || '',
        permissions
      }, () => this.listAllowedPermissions())
    })
  }

  componentDidMount () {
    this.readUser()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <Card>
            <PageHeading
              text={i18n("Edit User")}
              doc='users-edit-user' />
            <Row column={2}>
              <InputText
                name="username"
                value={this.state.username}
                label={i18n("Username")}
                onChange={this.handleInputChange} />
              <InputText
                name="timeout"
                value={this.state.timeout}
                label={i18n("Timeout")}
                onChange={this.handleInputChange} />
              <InputText
                name="email"
                value={this.state.email}
                label={i18n("Email")}
                onChange={this.handleInputChange} />
              <InputText
                name="phone"
                value={this.state.phone}
                label={i18n("Phone")}
                onChange={this.handleInputChange} />
              <InputText
                name="password"
                value={this.state.password}
                label={i18n("Password")}
                onChange={this.handleInputChange} />
              <Checkbox
                name="notify"
                label="Notify user via mail"
                checked={this.state.notify}
                align="center"
                onChange={this.handleCheckChange} />
            </Row>
            <Row column={1}>
              <PermissionPicker
                allowed={this.allowedPermissionNames}
                permissions={this.permissionNames}
                onChange={this.handlePermissionsChange} />
            </Row>
            <CardButton
              proceedText={i18n("Save")}
              cancelText={i18n("Cancel")}
              onProceedClick={this.handleSaveClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(UserEdit)
